(function () {
  'use strict';

  document.querySelectorAll('[data-efs-root]').forEach(function (root) {
    var jsonNode = root.querySelector('[data-efs-product-json]');
    if (!jsonNode) return;

    var product;

    try {
      product = JSON.parse(jsonNode.textContent);
    } catch (error) {
      return;
    }

    var scentButtons = Array.from(
      root.querySelectorAll('[data-efs-scent]')
    );

    var colorButtons = Array.from(
      root.querySelectorAll('[data-efs-color]')
    );

    var resultScent =
      root.querySelector('[data-efs-result-scent]');

    var resultColor =
      root.querySelector('[data-efs-result-color]');

    var resultPrice =
      root.querySelector('[data-efs-result-price]');

    var resultImage =
      root.querySelector('[data-efs-result-image]');

    var status =
      root.querySelector('[data-efs-status]');

    var add =
      root.querySelector('[data-efs-add]');

    var finalScent =
      root.querySelector('[data-efs-final-scent]');

    var finalColor =
      root.querySelector('[data-efs-final-color]');

    var finalVariantId =
      root.querySelector('[data-efs-final-variant-id]');

    var finalPrice =
      root.querySelector('[data-efs-final-price]');

    var finalImage =
      root.querySelector('[data-efs-final-image]');

    var finalAdd =
      root.querySelector('[data-efs-final-add]');

    var paymentWrap =
      root.querySelector('[data-efs-payment-wrap]');

    var selectedScent = '';
    var selectedColor = '';


    /* =========================
       HELPERS
    ========================= */

    function norm(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[\s　_\-・]/g, '');
    }


    function money(cents) {
      return (
        '¥' +
        Math.round(
          Number(cents || 0) / 100
        ).toLocaleString('ja-JP') +
        '（税込）'
      );
    }


    function optionIndex(
      pattern,
      fallback
    ) {
      var index =
        (product.options || []).findIndex(
          function (option) {
            return pattern.test(
              norm(option)
            );
          }
        );

      return index < 0
        ? fallback
        : index;
    }


    var scentIndex =
      optionIndex(
        /香|scent|fragrance|aroma/,
        0
      );


    var colorIndex =
      optionIndex(
        /色|カラー|color/,
        scentIndex === 0 ? 1 : 0
      );


    /* =========================
       VARIANT
    ========================= */

    function findVariant(
      color,
      scent
    ) {
      if (
        !color ||
        !scent
      ) {
        return null;
      }

      return (
        (product.variants || []).find(
          function (variant) {
            return (
              norm(
                variant.options[colorIndex]
              ) === norm(color) &&

              norm(
                variant.options[scentIndex]
              ) === norm(scent)
            );
          }
        ) || null
      );
    }


    function hasAvailableVariant(
      color,
      scent
    ) {
      return (
        product.variants || []
      ).some(
        function (variant) {

          if (!variant.available) {
            return false;
          }

          var colorMatches =
            !color ||
            norm(
              variant.options[colorIndex]
            ) === norm(color);

          var scentMatches =
            !scent ||
            norm(
              variant.options[scentIndex]
            ) === norm(scent);

          return (
            colorMatches &&
            scentMatches
          );
        }
      );
    }


    /* =========================
       BUTTON LOOKUP
    ========================= */

    function findScentButton(value) {
      return (
        scentButtons.find(
          function (button) {
            return (
              norm(
                button.dataset.efsScent
              ) === norm(value)
            );
          }
        ) || null
      );
    }


    function findColorButton(value) {
      return (
        colorButtons.find(
          function (button) {
            return (
              norm(
                button.dataset.efsColor
              ) === norm(value)
            );
          }
        ) || null
      );
    }


    function setActive(
      buttons,
      activeButton
    ) {
      buttons.forEach(
        function (button) {

          var active =
            button === activeButton;

          button.classList.toggle(
            'is-selected',
            active
          );

          button.setAttribute(
            'aria-pressed',
            active
              ? 'true'
              : 'false'
          );
        }
      );
    }


    /* =========================
       DISPLAY NAME
    ========================= */

    function displayScent() {
      var button =
        findScentButton(
          selectedScent
        );

      return (
        button &&
        button.dataset.efsScentName
          ? button.dataset.efsScentName
          : selectedScent
      );
    }


    function displayColor() {
      var button =
        findColorButton(
          selectedColor
        );

      return (
        button &&
        button.dataset.efsColorName
          ? button.dataset.efsColorName
          : selectedColor
      );
    }


    /* =========================
       IMAGE
    ========================= */

    function colorKey(color) {
      var button =
        findColorButton(color);

      var value =
        norm(color);

      var name =
        button
          ? norm(
              button.dataset.efsColorName
            )
          : '';

      var combined =
        value + ' ' + name;

      if (
        combined.indexOf('black') !== -1 ||
        combined.indexOf('ブラック') !== -1 ||
        combined.indexOf('黒') !== -1
      ) {
        return 'black';
      }

      return 'white';
    }


    function getImageForColor(
      imageNode,
      color,
      variant
    ) {
      if (!imageNode) {
        return '';
      }

      /*
        香り＋カラーが揃ったら
        variant画像を最優先
      */

      if (
        variant &&
        variant.image
      ) {
        return variant.image;
      }

      /*
        カラーだけ決まっている時
      */

      if (!color) {
        return '';
      }

      var key =
        colorKey(color);

      var configured =
        imageNode.getAttribute(
          'data-' + key + '-src'
        );

      if (configured) {
        return configured;
      }

      var button =
        findColorButton(color);

      if (
        button &&
        button.dataset.efsImage
      ) {
        return button.dataset.efsImage;
      }

      return '';
    }


    function setImage(
      imageNode,
      color,
      variant
    ) {
      if (
        !imageNode ||
        !color
      ) {
        return;
      }

      var src =
        getImageForColor(
          imageNode,
          color,
          variant
        );

      if (!src) {
        return;
      }

      if (
        imageNode.getAttribute('src') !== src
      ) {
        imageNode.src =
          src;
      }

      imageNode.alt =
        'ETERNAL FLOWER Aroma Spray ' +
        (
          displayColor() ||
          color
        );
    }


    /* =========================
       PRELOAD
    ========================= */

    function preloadImages() {
      var sources = [];


      function addSource(src) {
        if (
          src &&
          sources.indexOf(src) === -1
        ) {
          sources.push(src);
        }
      }


      [
        resultImage,
        finalImage
      ].forEach(
        function (imageNode) {

          if (!imageNode) return;

          addSource(
            imageNode.getAttribute(
              'data-white-src'
            )
          );

          addSource(
            imageNode.getAttribute(
              'data-black-src'
            )
          );

        }
      );


      colorButtons.forEach(
        function (button) {

          addSource(
            button.dataset.efsImage
          );

        }
      );


      (product.variants || []).forEach(
        function (variant) {

          addSource(
            variant.image
          );

        }
      );


      sources.forEach(
        function (src) {

          var image =
            new Image();

          image.src =
            src;

        }
      );
    }


    /* =========================
       STOCK
    ========================= */

    function setStockState(
      button,
      soldOut
    ) {
      button.disabled =
        soldOut;

      button.classList.toggle(
        'is-sold-out',
        soldOut
      );

      button.setAttribute(
        'aria-disabled',
        soldOut
          ? 'true'
          : 'false'
      );


      var label =
        button.querySelector(
          '.efs-stock-label'
        );


      if (soldOut) {

        if (!label) {

          label =
            document.createElement(
              'span'
            );

          label.className =
            'efs-stock-label';

          label.textContent =
            'SOLD OUT';

          label.setAttribute(
            'aria-label',
            '在庫切れ'
          );

          button.appendChild(
            label
          );
        }

      } else if (label) {

        label.remove();

      }
    }


    function getOriginalOptionLabel(
      option
    ) {
      if (
        !option.dataset.efsOriginalLabel
      ) {
        option.dataset.efsOriginalLabel =
          option.textContent
            .trim()
            .replace(
              /\s*｜SOLD OUT$/,
              ''
            );
      }

      return (
        option.dataset.efsOriginalLabel
      );
    }


    function refreshFinalSelectStock() {

      /*
        下部フォーム｜香り
      */

      if (finalScent) {

        Array.from(
          finalScent.options
        ).forEach(
          function (option) {

            if (!option.value) {
              return;
            }


            var soldOut =
              !hasAvailableVariant(
                selectedColor || '',
                option.value
              );


            option.disabled =
              soldOut;


            option.textContent =
              getOriginalOptionLabel(
                option
              ) +
              (
                soldOut
                  ? '｜SOLD OUT'
                  : ''
              );

          }
        );
      }


      /*
        下部フォーム｜カラー
      */

      if (finalColor) {

        Array.from(
          finalColor.options
        ).forEach(
          function (option) {

            if (!option.value) {
              return;
            }


            var soldOut =
              !hasAvailableVariant(
                option.value,
                selectedScent || ''
              );


            option.disabled =
              soldOut;


            option.textContent =
              getOriginalOptionLabel(
                option
              ) +
              (
                soldOut
                  ? '｜SOLD OUT'
                  : ''
              );

          }
        );
      }
    }


    function refreshStock() {

      /*
        STEP 1｜香り

        カラー未選択：
        どちらかのカラーで在庫があれば選択可

        カラー選択済み：
        そのカラーで在庫がある香りだけ選択可
      */

      scentButtons.forEach(
        function (button) {

          var scent =
            button.dataset.efsScent || '';


          var soldOut =
            !hasAvailableVariant(
              selectedColor || '',
              scent
            );


          setStockState(
            button,
            soldOut
          );

        }
      );


      /*
        STEP 2｜カラー

        香り未選択：
        どれかの香りで在庫があれば選択可

        香り選択済み：
        その香りで在庫があるカラーだけ選択可
      */

      colorButtons.forEach(
        function (button) {

          var color =
            button.dataset.efsColor || '';


          var soldOut =
            !hasAvailableVariant(
              color,
              selectedScent || ''
            );


          setStockState(
            button,
            soldOut
          );

        }
      );


      /*
        下部カートにも
        SOLD OUTを同期
      */

      refreshFinalSelectStock();
    }


    /* =========================
       FINAL FORM
    ========================= */

    function syncFinalControls() {

      if (finalScent) {
        finalScent.value =
          selectedScent || '';
      }

      if (finalColor) {
        finalColor.value =
          selectedColor || '';
      }

    }


    function resetFinalVariant() {

      syncFinalControls();


      if (finalVariantId) {
        finalVariantId.value = '';
      }


      if (finalAdd) {
        finalAdd.disabled = true;
      }


      if (paymentWrap) {
        paymentWrap.hidden = true;
      }
    }


    function syncFinalVariant(variant) {

      if (!variant) {

        resetFinalVariant();

        return;
      }


      syncFinalControls();


      if (finalVariantId) {

        finalVariantId.value =
          String(variant.id);


        finalVariantId.dispatchEvent(
          new Event(
            'input',
            {
              bubbles: true
            }
          )
        );


        finalVariantId.dispatchEvent(
          new Event(
            'change',
            {
              bubbles: true
            }
          )
        );

      }


      if (finalPrice) {

        finalPrice.textContent =
          money(
            variant.price
          );

      }


      if (finalAdd) {

        finalAdd.disabled =
          !variant.available;

      }


      if (paymentWrap) {

        paymentWrap.hidden =
          !variant.available;

      }


      setImage(
        finalImage,
        selectedColor,
        variant
      );

    }


    /* =========================
       UPDATE
    ========================= */

    function update() {

      /*
        まずSOLD OUT表示を更新
      */

      refreshStock();


      var variant =
        findVariant(
          selectedColor,
          selectedScent
        );


      /* RESULT SCENT */

      if (resultScent) {

        resultScent.textContent =
          selectedScent
            ? displayScent()
            : '香りを選択してください';

      }


      /* RESULT COLOR */

      if (resultColor) {

        resultColor.textContent =
          selectedColor
            ? displayColor()
            : 'カラーを選択してください';

      }


      /*
        カラーが決まったら
        04画像を変更
      */

      if (selectedColor) {

        setImage(
          resultImage,
          selectedColor,
          variant
        );

      }


      /* CENTER CART */

      if (add) {

        add.dataset.variantId =
          variant
            ? String(variant.id)
            : '';


        add.disabled =
          !variant ||
          !variant.available;

      }


      /* NOTHING SELECTED */

      if (
        !selectedScent &&
        !selectedColor
      ) {

        if (status) {

          status.textContent =
            '香りとカラーをお選びください。';

        }


        resetFinalVariant();

        return;
      }


      /* NO SCENT */

      if (!selectedScent) {

        if (status) {

          status.textContent =
            '香りを1種類お選びください。';

        }


        resetFinalVariant();

        return;
      }


      /* NO COLOR */

      if (!selectedColor) {

        if (status) {

          status.textContent =
            'ボトルカラーをお選びください。';

        }


        resetFinalVariant();

        return;
      }


      /* NO VARIANT */

      if (!variant) {

        if (status) {

          status.textContent =
            '選択した組み合わせの商品情報が見つかりませんでした。商品オプションの値をご確認ください。';

        }


        resetFinalVariant();

        return;
      }


      /* PRICE */

      if (resultPrice) {

        resultPrice.textContent =
          money(
            variant.price
          );

      }


      /* STATUS */

      if (status) {

        status.textContent =
          variant.available
            ? '選択内容をご確認のうえ、カートへお進みください。'
            : 'この組み合わせは、ただいま在庫切れです。';

      }


      /*
        FINAL FORMへ同期
      */

      syncFinalVariant(
        variant
      );

    }


    /* =========================
       SCROLL
    ========================= */

    function scrollToResult() {

      var result =
        root.querySelector(
          '[data-efs-result]'
        );


      if (!result) return;


      setTimeout(
        function () {

          result.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

        },
        100
      );

    }


    /* =========================
       SCENT CLICK
    ========================= */

    scentButtons.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {


            if (button.disabled) {
              return;
            }


            selectedScent =
              button.dataset.efsScent || '';


            setActive(
              scentButtons,
              button
            );


            update();


            if (selectedColor) {
              scrollToResult();
            }

          }
        );

      }
    );


    /* =========================
       COLOR CLICK
    ========================= */

    colorButtons.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {


            if (button.disabled) {
              return;
            }


            selectedColor =
              button.dataset.efsColor || '';


            setActive(
              colorButtons,
              button
            );


            setImage(
              resultImage,
              selectedColor,
              findVariant(
                selectedColor,
                selectedScent
              )
            );


            update();


            if (selectedScent) {
              scrollToResult();
            }

          }
        );

      }
    );


    /* =========================
       FINAL FORM → TOP
    ========================= */

    function updateFromFinalForm() {

      selectedScent =
        finalScent
          ? finalScent.value
          : '';


      selectedColor =
        finalColor
          ? finalColor.value
          : '';


      setActive(
        scentButtons,
        findScentButton(
          selectedScent
        )
      );


      setActive(
        colorButtons,
        findColorButton(
          selectedColor
        )
      );


      update();

    }


    if (finalScent) {

      finalScent.addEventListener(
        'change',
        updateFromFinalForm
      );

    }


    if (finalColor) {

      finalColor.addEventListener(
        'change',
        updateFromFinalForm
      );

    }


    /* =========================
       ADD TO CART
       04 RESULT
    ========================= */

    if (add) {

      add.addEventListener(
        'click',
        async function () {


          var id =
            Number(
              add.dataset.variantId
            );


          if (!id) {
            return;
          }


          var originalLabel =
            add.textContent;


          add.disabled = true;


          add.textContent =
            '追加中…';


          try {

            var response =
              await fetch(
                '/cart/add.js',
                {

                  method:
                    'POST',


                  headers: {

                    'Content-Type':
                      'application/json',

                    'Accept':
                      'application/json'

                  },


                  body:
                    JSON.stringify({

                      items: [

                        {

                          id: id,

                          quantity: 1

                        }

                      ]

                    })

                }
              );


            if (!response.ok) {

              var body =
                await response
                  .json()
                  .catch(
                    function () {

                      return {};

                    }
                  );


              throw new Error(
                body.description ||
                'カートへの追加に失敗しました。'
              );

            }


            add.textContent =
              'カートに追加しました ✓';


            if (status) {

              status.textContent =
                'カートに追加しました。';

            }


            document.dispatchEvent(
              new CustomEvent(
                'cart:refresh'
              )
            );


            document.dispatchEvent(
              new CustomEvent(
                'cart:updated'
              )
            );


            setTimeout(
              function () {


                add.textContent =
                  originalLabel;


                var currentVariant =
                  findVariant(
                    selectedColor,
                    selectedScent
                  );


                add.disabled =
                  !currentVariant ||
                  !currentVariant.available;

              },
              2500
            );


          } catch (error) {


            if (status) {

              status.textContent =
                error.message ||
                'カートへの追加に失敗しました。';

            }


            add.textContent =
              originalLabel;


            var currentVariant =
              findVariant(
                selectedColor,
                selectedScent
              );


            add.disabled =
              !currentVariant ||
              !currentVariant.available;

          }

        }
      );

    }


    /* =========================
       INITIAL STATE
    ========================= */

    selectedScent = '';

    selectedColor = '';


    setActive(
      scentButtons,
      null
    );


    setActive(
      colorButtons,
      null
    );


    resetFinalVariant();

    update();

    preloadImages();

  });

})();